import { DisplayEventsEventNoProducts, GetDisplayEventContents, GetDisplayEventsResponse } from '@shopby/shop-sdk'
import { chunk } from 'lodash'
import { useCallback, useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
// import { Helmet } from 'react-helmet'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { FreeMode } from 'swiper/modules'
import { Swiper } from 'swiper/react'
import { Categories, DisplayEventsEventNo, MultiLevelCategoryItem } from '../../@types/exhibition'
import { getEventDetail, getEvents } from '../../api/home'
import EventSortLayer from '../../components/event/EventSortLayer'
import EventSortModal from '../../components/event/EventSortModal'
import ProductItem from '../../components/exhibition/ProductItem'
import ProductListItem from '../../components/exhibition/ProductListItem'
import Hr8 from '../../components/hr/Hr8'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import ProductModal from '../../components/product/ProductModal'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { usePromotionContext } from '../../components/provider/PromotionProvider'
import '../../css/Exhibition.css'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { SwiperSlideItem } from '../Category'
import { IMAGE_PATH } from '../util/common'
import SliceItem from './exhibition-detail-slice-item'
import { useMyContext } from '../../components/provider/MyProvider'
import SEO from '../../SEO'

const ExhibitionDetail = () => {
  const [eventDetailData, setEventDetailData] = useState<DisplayEventsEventNo>()
  const [eventData, setEventData] = useState<GetDisplayEventContents[]>([])
  const [categoryMenu, setCategoryMenu] = useState<Categories>()
  const [productList, setProductList] = useState<DisplayEventsEventNoProducts[]>([])
  const [type, setType] = useState<string>('thumb')
  const [selectProductNo, setSelectProductNo] = useState<string>('')
  const [isModal, setIsModal] = useState<boolean>(false)
  const [isSort, setIsSort] = useState<boolean>(false)
  const [sortKeyword, setSortKeyword] = useState<string>('ADMIN_SETTING') //정렬값
  const [sortKeywordLabel, setSortKeywordLabel] = useState<string>('추천순') //정렬 텍스트
  const [sortDirection, setSortDirection] = useState<string>('DESC') //정렬 내림차순?오름차순
  const [isSortIcon, setIsSortIcon] = useState<boolean>(false)
  const [isTouchMoving, setIsTouchMoving] = useState(false)
  const [cartIndex, setCartIndex] = useState<number>(0)
  const [page, setPage] = useState<number>(1) // 현재 페이지
  const [checkMainImageLoad, setCheckMainImageLoad] = useState<boolean>(false)
  const [categoryNo, setCategoryNo] = useState<number>(0)

  const [filteredCategories, setFilteredCategories] = useState<MultiLevelCategoryItem[]>([])

  const { findCategory, categories } = useMyContext()
  const pageSize = 8 // 한 번에 로드할 데이터 개수
  const itemRef = useRef(null)
  const btnSortRef = useRef(null)
  const category4WrapRef = useRef<HTMLDivElement | null>(null)
  const categoryFourSubMenuWrapRef = useRef(null)
  const obsRef = useRef(null)
  const exhibitionMainImgRef = useRef<HTMLImageElement>(null)
  const dataRef = useRef<DisplayEventsEventNoProducts[]>([])
  const preventRef = useRef(true) //옵저버 중복 실행 방지
  const endRef = useRef(false) //모든 글 로드 확인
  const mainImageRef = useRef<any>(null)
  const result = categoryMenu ? findCategory(categoryMenu, categoryNo) : null
  const navigate = useNavigate()
  const { isAppView } = useAppContext()
  const { setPromotionTitle } = usePromotionContext()
  const { setIsLottie } = useCommonContext()
  const params = useParams()

  //카테고리 선택시 선택여부 변경
  const makeSelectCategory = (
    itemList: MultiLevelCategoryItem[],
    index: number,
    data: MultiLevelCategoryItem
  ): MultiLevelCategoryItem[] => {
    return itemList.map((item) => {
      if (item.depth === data.depth) {
        // 같은 depth에서 선택된 항목이면 선택 해제, 아니면 선택 상태 토글
        if (item.categoryNo === data.categoryNo) {
          return { ...item, isSelected: !item.isSelected }
        }
        if (item.isSelected) {
          return { ...item, isSelected: false }
        }
      }
      // 하위 카테고리 재귀 처리
      if (item.children) {
        return { ...item, children: makeSelectCategory(item.children, index + 1, data) }
      }
      return item
    })
  }

  const onChangeCategory = (data?: MultiLevelCategoryItem) => {
    if (data) {
      const currentCategory = data.depth === 2 ? filteredCategories || [] : categoryMenu?.multiLevelCategories || []
      const saveData = makeSelectCategory(currentCategory, 0, data)
      setCategoryMenu((prev) => ({ ...prev, multiLevelCategories: saveData }))
    } else {
      setCategoryMenu((prev) => ({ ...prev, multiLevelCategories: filteredCategories }))
    }
  }

  //상품의 no의 배열 만드는 함수
  const getProductDisplayNo = (products?: DisplayEventsEventNoProducts[]) => {
    return products?.map((item) => item.displayCategoryNos?.split('|')).flat()
  }

  //상품이 있는 카테고리만 필터링
  const filterCategoriesWithProducts = (
    categories: MultiLevelCategoryItem[],
    productDisplayNoList?: (string | undefined)[]
  ): MultiLevelCategoryItem[] => {
    return categories
      .map((item) => {
        const isMatchingDepth =
          (item.depth === 3 || item.depth === 4) && productDisplayNoList?.includes(item.categoryNo?.toString())
        if (isMatchingDepth) return item
        if (item.children) {
          const filteredChildren = filterCategoriesWithProducts(item.children, productDisplayNoList)
          if (filteredChildren.length > 0) {
            return { ...item, children: filteredChildren }
          }
        }
        return null
      })
      .filter((item): item is MultiLevelCategoryItem => item !== null)
  }

  // useEffect(() => {
  //   console.log(location.search)
  // }, [location])

  //기획전 & 이벤트 리스트 만들기
  const makeEventList = (contents: GetDisplayEventContents[]) => {
    const filteredContents = contents.filter((item) => Number(item.eventNo) !== 43284)

    const index = filteredContents.findIndex((item) => Number(item.eventNo) === Number(params.eventNo))

    const eventItems = []

    if (index === -1) return

    if (index < 2) {
      // idx가 0 또는 1인 경우
      if (index === 0) {
        eventItems.push(filteredContents[index + 1], filteredContents[index + 2], filteredContents[index + 3])
      } else {
        // idx === 1
        eventItems.push(filteredContents[index - 1], filteredContents[index + 1], filteredContents[index + 2])
      }
    } else if (index === filteredContents.length - 1) {
      // 마지막 아이템인 경우
      eventItems.push(filteredContents[index], filteredContents[index - 2], filteredContents[index - 3])
    } else {
      // 일반적인 경우
      eventItems.push(filteredContents[index - 2], filteredContents[index - 1], filteredContents[index + 1])
    }
    setEventData(eventItems)
  }

  const init = useCallback(async () => {
    try {
      if (params.eventNo !== undefined && categories) {
        const eventDetailRes: { data: DisplayEventsEventNo } = await getEventDetail(params.eventNo, sortKeyword)
        const eventsRes: { data: GetDisplayEventsResponse } = await getEvents('')

        const deleteBrandCategory = categories.multiLevelCategories?.filter((item) => item.label !== '브랜드')
        const productDisplayNoList = getProductDisplayNo(eventDetailRes.data.section?.[0].products)
        const filteredCategories = filterCategoriesWithProducts(deleteBrandCategory || [], productDisplayNoList)

        setFilteredCategories(filteredCategories || [])
        setIsLottie(false)
        setPromotionTitle({
          promotion_id: eventDetailRes.data.eventNo,
          promotion_name: eventDetailRes.data.label,
        })
        mainImageRef.current = eventDetailRes.data.top
        setEventDetailData(eventDetailRes.data)
        makeEventList(eventsRes.data.contents)

        setCategoryMenu({ ...categories, multiLevelCategories: filteredCategories })
      }
    } catch (error) {
      console.error(error)
    }
  }, [categories])

  useEffect(() => {
    // 정렬값이 바뀌면 상품만 다시 불러오기
    if (eventDetailData) {
      ;(async () => {
        if (!params.eventNo) return
        const eventDetailRes: { data: DisplayEventsEventNo } = await getEventDetail(params.eventNo, sortKeyword)
        setEventDetailData(eventDetailRes.data)
        // NOTE 테스트 후 정상 작동하지 않을 시 getProductList() 함수를 호출하여 상품 목록을 업데이트 할 수도 있음.
      })()
    }
  }, [sortKeyword])

  useEffect(() => {
    if (categories) init()
  }, [categories, init])

  const findFirstCategory = () => {
    const finde2depCategoryNo = findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)?.categoryNo
    return categoryMenu?.flatCategories?.find((item) => {
      return item.depth2CategoryNo === finde2depCategoryNo
    })
  }

  //gtm데이터
  const sendDataToTagManager = () => {
    const firstCategory = findFirstCategory()
    const makeGtm = productList?.map((item, index) => ({
      item_id: String(item?.productNo),
      item_name: item?.productName,
      affiliation: '어바웃피싱',
      item_list_price: item?.salePrice,
      item_selling_price: (item?.salePrice || 0) - (item?.immediateDiscountAmt || 0),
      price: (item?.salePrice || 0) - (item?.immediateDiscountAmt || 0),
      item_total_discount: item?.immediateDiscountAmt,
      discount: 0,
      index: index,
      item_brand: item?.brandName,
      item_category: firstCategory?.depth1Label || '전체',
      item_category2: findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)?.label || '',
      item_category3: findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0)?.label || '',
      promotion_id: String(eventDetailData?.eventNo),
      promotion_name: eventDetailData?.label,
    }))

    const chunks = chunk(makeGtm, 25) // 50개씩 자름
    chunks.forEach((chunk) => {
      const gtmClickItem: DataLayerArgs = {
        dataLayer: {
          event: 'view_promotion', // ecommerce 이벤트 중 상품보기 단계
          ecommerce: {
            item_list_count: chunk.length, // 현재 청크의 아이템 개수
            items: chunk,
          },
        },
      }

      if (isAppView) {
        sendSetAppsflyerEvent({
          eventName: 'view_promotion',
          eventType: {
            item_list_count: chunk.length, // 현재 청크의 아이템 개수
            items: chunk,
          },
        })
      } else {
        TagManager.dataLayer(gtmClickItem)
      }
    })
  }

  //현재 선택된 카테고리 (deps에 따라 선택된 카테고리 찾기)
  const findSelectedCategoryItem = (
    itemList: MultiLevelCategoryItem[] = [],
    deps: number,
    index: number = 0
  ): MultiLevelCategoryItem | undefined => {
    if (!itemList || itemList.length === 0) return undefined

    for (let i = index; i < itemList.length; i++) {
      const item = itemList[i]
      if (item.isSelected && item.depth === deps) {
        return item
      }
      if (item.children) {
        const foundItem = findSelectedCategoryItem(item.children, deps)
        if (foundItem) {
          return foundItem
        }
      }
    }
    return undefined
  }

  //해당 deps가 있는지 찾기
  const findCategoryDeps = (
    itemList: MultiLevelCategoryItem[],
    deps: number,
    index: number
  ): MultiLevelCategoryItem[] | [] => {
    const findSelectedCategories = itemList.filter((item) => item.depth === deps && item.label !== '브랜드')
    if (findSelectedCategories.length > 0) {
      return findSelectedCategories
    } else if (itemList[index]?.children) {
      return findCategoryDeps(itemList[0].children || [], deps, index + 1)
    } else {
      return []
    }
  }
  //모든 카테고리 No
  const getAllCategoryNos = (category: MultiLevelCategoryItem): (number | undefined)[] => {
    let categoryNos: (number | undefined)[] = [category.categoryNo]
    if (category.children) {
      category.children.forEach((child) => {
        categoryNos = categoryNos.concat(getAllCategoryNos(child))
      })
    }
    return categoryNos
  }

  //카테고리 선택시 product리스트 가져오기
  const getProductList = useCallback(() => {
    const checkCurrentDeps =
      findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 4, 0) ||
      findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0) ||
      findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)

    const totalList = eventDetailData?.section?.[0].products

    if (checkCurrentDeps && totalList) {
      const categoryNoList = getAllCategoryNos(checkCurrentDeps)
      const selectedProducts = totalList.filter((product) =>
        categoryNoList.some(
          (categoryNo) => categoryNo && product.displayCategoryNos?.split('|').includes(categoryNo.toString())
        )
      )
      dataRef.current = selectedProducts
      setProductList(selectedProducts.slice(0, 8))
    } else if (totalList !== undefined) {
      dataRef.current = totalList
      setProductList(totalList.slice(0, 8))
    }
  }, [categoryMenu, eventDetailData])

  const CheckImageLoad = () => {
    if (exhibitionMainImgRef.current?.offsetHeight !== undefined && exhibitionMainImgRef.current?.offsetHeight > 30) {
      setCheckMainImageLoad(true)
    }
  }

  useEffect(() => {
    init()
  }, [init])

  useEffect(() => {
    getProductList()
  }, [getProductList])

  useEffect(() => {
    sendDataToTagManager()
  }, [productList])

  useEffect(() => {
    if (category4WrapRef.current !== null) {
      if (findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0)) {
        category4WrapRef.current.style.borderBottom = 'none'
      } else {
        category4WrapRef.current.style.borderBottom = '1px solid var(--colGray3)'
      }
    }
  }, [])

  useEffect(() => {
    if (dataRef.current.length !== 0) {
      getPost()
      preventRef.current = true
    }
  }, [page, dataRef.current])

  const getPost = useCallback(async () => {
    loadMoreData()
  }, [page])
  // 데이터 추가 로드
  const loadMoreData = () => {
    // const nextPage = page + 1;
    const startIndex = page * pageSize
    const endIndex = startIndex + pageSize
    const newProducts = dataRef.current.slice(startIndex, endIndex)
    if (newProducts.length > 0) {
      if (page === 0) {
        setProductList(newProducts)
      } else {
        setProductList((prev) => [...prev, ...newProducts])
      } // 기존 데이터에 추가
      // setPage(nextPage); // 페이지 증가
    }
  }

  useEffect(() => {
    if (!productList) return

    const mutationObserver = new MutationObserver(() => {
      if (obsRef.current && itemRef.current) {
        const observer = new IntersectionObserver(obsHandler, { threshold: 0.6 })
        observer.observe(obsRef.current)
        mutationObserver.disconnect() // 초기화 후 더는 필요 없으므로 중단

        return () => observer.disconnect()
      }
    })

    mutationObserver.observe(document.body, { childList: true, subtree: true })

    return () => mutationObserver.disconnect()
  }, [productList, itemRef, location.pathname])

  const obsHandler = (entries: any) => {
    //옵저버 콜백함수
    const target = entries[0]
    if (!endRef.current && target.isIntersecting && preventRef.current) {
      //옵저버 중복 실행 방지
      preventRef.current = false //옵저버 중복 실행 방지
      setPage((prev) => prev + 1) //페이지 값 증가
    }
  }

  const touchMove = () => {
    setIsTouchMoving(true)
  }

  const touchEnd = () => {
    setIsTouchMoving(false)
  }

  const navigationHandler = (
    event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
    type: 'exhibitionDetail' | 'exhibitionList',
    item?: GetDisplayEventContents
  ) => {
    event.preventDefault()

    const baseUrl = process.env.REACT_APP_SHOP_URL
    const url =
      type === 'exhibitionDetail'
        ? `aboutfishing://aboutfishing.com/?page=webview&url=${baseUrl}/exhibitiondetail/${item?.eventNo}`
        : `aboutfishing://aboutfishing.com/?page=webview&url=${baseUrl}/exhibitionlist`

    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, { url })
    } else {
      navigate(type === 'exhibitionDetail' ? `/product/${item?.eventNo}` : '/exhibitionlist')
    }
  }

  return (
    <>
      <div style={{ width: '1px', height: '1px', textIndent: '-9999', opacity: 0 }}>
        {isMobile
          ? eventDetailData?.top?.mobile?.url && (
              <div>
                <img src={`${eventDetailData?.top?.mobile?.url}`} alt='' width='100%' />
              </div>
            )
          : eventDetailData?.top?.pc?.url && (
              <div>
                <img src={`${eventDetailData?.top?.pc?.url}`} alt='' width='100%' />
              </div>
            )}
      </div>
      {/* <Helmet>
        <meta property="og:title" content={eventDetailData?.label} />
        <title>{`${eventDetailData?.label} - 어바웃피싱`}</title>
        <meta property="og:type" content="event" />
        <meta
          property="og:image"
          content={isMobile ? `https:${eventDetailData?.mobileimageUrl}` : `https:${eventDetailData?.pcImageUrl}`}
        />
        <meta
          property="og:image:secure_url"
          content={isMobile ? `https:${eventDetailData?.mobileimageUrl}` : `https:${eventDetailData?.pcImageUrl}`}
        />
        <meta name="description" content={eventDetailData?.label} />
        <meta name="keywords" content={eventDetailData?.label} />
      </Helmet> */}
      {location.pathname.includes('exhibitiondetail') && (
        <SEO
          title={`${eventDetailData?.label} - 어바웃피싱`}
          image={isMobile ? `https:${eventDetailData?.mobileimageUrl}` : `https:${eventDetailData?.pcImageUrl}`}
        ></SEO>
      )}
      <div className='main_wrap '>
        <div className='exhibition_detail_cont'>
          {isMobile
            ? mainImageRef.current?.mobile?.url && (
                <div className='visual_img' ref={exhibitionMainImgRef}>
                  <img
                    src={`${mainImageRef.current?.mobile?.url}`}
                    alt=''
                    width='100%'
                    onLoad={() => {
                      CheckImageLoad()
                    }}
                  />
                </div>
              )
            : mainImageRef.current?.pc?.url && (
                <div className='visual_img' ref={exhibitionMainImgRef}>
                  <img
                    src={`${mainImageRef.current?.pc?.url}`}
                    alt=''
                    width='100%'
                    onLoad={() => {
                      CheckImageLoad()
                    }}
                  />
                </div>
              )}
          {checkMainImageLoad && (
            <>
              <CategoryWrap
                className='category_wrap exhibition_category_header'
                $isAll={!findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)}
              >
                <div className='category'>
                  <div className='inner'>
                    <SwiperWrap
                      slidesPerView={'auto'}
                      spaceBetween={12}
                      breakpoints={{
                        768: {
                          spaceBetween: 20,
                        },
                      }}
                      modules={[FreeMode]}
                      freeMode={true}
                      centeredSlidesBounds={true}
                      slideToClickedSlide={true}
                      onTouchMove={touchMove}
                      onTouchEnd={touchEnd}
                    >
                      <SwiperSlideItem>
                        <div
                          className={
                            !findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0) ? 'on' : ' '
                          }
                        >
                          <a
                            className='all'
                            onTouchEnd={(e) => {
                              e.preventDefault()
                              if (isMobile && !isTouchMoving) {
                                onChangeCategory(undefined)
                                //window.scrollTo(0, Number(exhibitionMainImgRef.current?.offsetHeight));
                              }
                              setPage(0)
                              setProductList([])
                            }}
                            onClick={(e) => {
                              e.preventDefault()
                              if (!isMobile) {
                                onChangeCategory(undefined)
                                //window.scrollTo(0, Number(exhibitionMainImgRef.current?.offsetHeight));
                              }
                              setPage(0)
                              setProductList([])
                            }}
                          >
                            전체
                          </a>
                        </div>
                      </SwiperSlideItem>

                      {findCategoryDeps(categoryMenu?.multiLevelCategories || [], 2, 0)?.map((item) => {
                        return (
                          <SwiperSlideItem key={item?.categoryNo}>
                            <SliceItem
                              data={item}
                              imageHeight={exhibitionMainImgRef.current?.offsetHeight}
                              isTouchMoving={isTouchMoving}
                              onChangeCategory={onChangeCategory}
                              findSelectedCategoryItem={findSelectedCategoryItem(
                                categoryMenu?.multiLevelCategories || [],
                                2,
                                0
                              )}
                              setPage={setPage}
                              setProductList={setProductList}
                              setCategoryNo={setCategoryNo}
                            />
                          </SwiperSlideItem>
                        )
                      })}
                    </SwiperWrap>
                  </div>
                </div>
              </CategoryWrap>
              {findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0) && (
                <Category4Wrap
                  ref={category4WrapRef}
                  className='exhibition_category_header'
                  $isAll={!findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0)}
                >
                  <div className='category4'>
                    <div className='inner'>
                      <SwiperWrap
                        slidesPerView={'auto'}
                        spaceBetween={12}
                        breakpoints={{
                          768: {
                            spaceBetween: 20,
                          },
                        }}
                        modules={[FreeMode]}
                        freeMode={true}
                        centeredSlidesBounds={true}
                        slideToClickedSlide={true}
                        onTouchMove={touchMove}
                        onTouchEnd={touchEnd}
                      >
                        <SwiperSlideItem>
                          <div
                            className={
                              !findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0) ? 'on' : ''
                            }
                          >
                            <a
                              className='all'
                              onTouchEnd={(e) => {
                                e.preventDefault()
                                if (isMobile && !isTouchMoving) {
                                  onChangeCategory(
                                    findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)
                                  )
                                  //window.scrollTo(0, Number(exhibitionMainImgRef.current?.offsetHeight));
                                }
                                setPage(0)
                                setProductList([])
                              }}
                              onClick={(e) => {
                                e.preventDefault()
                                if (!isMobile) {
                                  onChangeCategory(
                                    findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)
                                  )
                                  //window.scrollTo(0, Number(exhibitionMainImgRef.current?.offsetHeight));
                                }
                                setPage(0)
                                setProductList([])
                              }}
                            >
                              전체
                            </a>
                          </div>
                        </SwiperSlideItem>
                        {findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)?.children?.map(
                          (item) => {
                            return (
                              <SwiperSlideItem key={item.categoryNo}>
                                <SliceItem
                                  data={item}
                                  imageHeight={exhibitionMainImgRef.current?.offsetHeight}
                                  isTouchMoving={isTouchMoving}
                                  onChangeCategory={onChangeCategory}
                                  findSelectedCategoryItem={findSelectedCategoryItem(
                                    categoryMenu?.multiLevelCategories || [],
                                    3,
                                    0
                                  )}
                                  setPage={setPage}
                                  setProductList={setProductList}
                                  setCategoryNo={setCategoryNo}
                                />
                              </SwiperSlideItem>
                            )
                          }
                        )}
                      </SwiperWrap>
                    </div>
                  </div>
                </Category4Wrap>
              )}
              {/* {(findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0)?.children || [])?.length >
                0 && (
                <CategoryFourSubMenuWrap
                  ref={categoryFourSubMenuWrapRef}
                  className='exhibition_category_header_four_submenu'
                >
                  <div className='category_four_submenu'>
                    <div className='inner'>
                      <SwiperWrap
                        slidesPerView={'auto'}
                        spaceBetween={12}
                        breakpoints={{
                          768: {
                            spaceBetween: 20,
                          },
                        }}
                        modules={[FreeMode]}
                        freeMode={true}
                        centeredSlidesBounds={true}
                        slideToClickedSlide={true}
                      >
                        <SwiperSlideItem>
                          <div
                            className={
                              !findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 4, 0) ? 'on' : ' '
                            }
                          >
                            <a
                              className='all'
                              onTouchEnd={(e) => {
                                e.preventDefault()
                                if (isMobile && !isTouchMoving) {
                                  onChangeCategory(
                                    findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 4, 0)
                                  )
                                  //window.scrollTo(0, Number(exhibitionMainImgRef.current?.offsetHeight));
                                  setPage(0)
                                  setProductList([])
                                }
                              }}
                              onClick={(e) => {
                                e.preventDefault()
                                if (!isMobile) {
                                  onChangeCategory(
                                    findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 4, 0)
                                  )
                                  //window.scrollTo(0, Number(exhibitionMainImgRef.current?.offsetHeight));
                                }
                                setPage(0)
                                setProductList([])
                              }}
                            >
                              전체
                            </a>
                          </div>
                        </SwiperSlideItem>
                        {findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0)?.children?.map(
                          (item) => {
                            return (
                              <SwiperSlideItem key={item?.categoryNo}>
                                <SliceItem
                                  data={item}
                                  imageHeight={exhibitionMainImgRef.current?.offsetHeight}
                                  isTouchMoving={isTouchMoving}
                                  onChangeCategory={onChangeCategory}
                                  findSelectedCategoryItem={findSelectedCategoryItem(
                                    categoryMenu?.multiLevelCategories || [],
                                    4,
                                    0
                                  )}
                                  setPage={setPage}
                                  setProductList={setProductList}
                                  setCategoryNo={setCategoryNo}
                                />
                              </SwiperSlideItem>
                            )
                          }
                        )}
                      </SwiperWrap>
                    </div>
                  </div>
                </CategoryFourSubMenuWrap>
              )} */}
            </>
          )}
          {/* 상품 목록 불러와서 사용해야 할 영역 */}
          {checkMainImageLoad && (
            <div className='product_list_wrap product'>
              {eventDetailData?.eventYn !== 'Y' && (
                <div className='item_list'>
                  <div className='product_list_header'>
                    <div className='product_list_num'>
                      <span>{dataRef?.current?.length}</span>개의 상품
                    </div>

                    <ul className='product_list_option'>
                      <li>
                        <button
                          ref={btnSortRef}
                          className='btn_sort'
                          onClick={() => {
                            setIsSort((prev: boolean) => !prev)
                            setIsSortIcon(!isSortIcon)
                          }}
                        >
                          {sortKeywordLabel ? sortKeywordLabel : '정렬'}
                          {!isMobile && isSortIcon ? (
                            <img src={`${IMAGE_PATH}/icon_arrow_up.png`} alt='' />
                          ) : (
                            <img src={`${IMAGE_PATH}/icon_arrow_down.png`} alt='' />
                          )}
                        </button>
                        {isSort &&
                          (isMobile ? (
                            <EventSortModal
                              headerText='정렬'
                              setIsModal={setIsSort}
                              setSortKeyword={setSortKeyword}
                              sortKeyword={sortKeyword}
                              setSortKeywordLabel={setSortKeywordLabel}
                              setSortDirection={setSortDirection}
                              sortDirection={sortDirection}
                            />
                          ) : (
                            <EventSortLayer
                              setIsModal={setIsSort}
                              setSortKeyword={setSortKeyword}
                              sortKeyword={sortKeyword}
                              setSortKeywordLabel={setSortKeywordLabel}
                              setSortDirection={setSortDirection}
                              sortDirection={sortDirection}
                              setIsSortIcon={setIsSortIcon}
                              btnSortRef={btnSortRef}
                            />
                          ))}
                      </li>

                      <li>
                        <button className='btn_listtype'>
                          <img
                            onClick={() => {
                              if (type === 'thumb') {
                                setType('list')
                              } else {
                                setType('thumb')
                              }
                            }}
                            src={`${
                              type === 'thumb' ? `${IMAGE_PATH}/icon_list.png` : `${IMAGE_PATH}/icon_list_thumb.png`
                            }`}
                            alt='상품보기 썸네일형'
                          />
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className={type === 'thumb' ? 'product_wrap' : 'product_wrap list'} ref={itemRef}>
                    {type === 'thumb' &&
                      productList?.map((item, index: number) => {
                        return (
                          <ProductItem
                            key={`${item.productNo}-${index}`}
                            data={item}
                            setIsModal={setIsModal}
                            index={index}
                            setSelectProductNo={setSelectProductNo}
                            totalCount={productList.length}
                            promotion_id={params?.eventNo}
                            promotion_name={eventDetailData?.label}
                            categoryData={categoryMenu?.flatCategories}
                            setCartIdx={setCartIndex}
                            item_category={
                              !findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)
                                ? '전체'
                                : findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)
                            }
                            item_category2={
                              findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 2, 0)?.label || ''
                            }
                            item_category3={
                              findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0)?.label || ''
                            }
                          />
                        )
                      })}
                    {type === 'list' &&
                      productList?.map((item, index: number) => {
                        return (
                          <ProductListItem
                            key={`${item.productNo}-${index}`}
                            item={item}
                            idx={index}
                            setIsModal={setIsModal}
                            setSelectProductNo={setSelectProductNo}
                            listItem={item}
                            totalCount={productList.length}
                            promotion_id={params?.eventNo}
                            promotion_name={eventDetailData?.label}
                            categoryData={result?.categoryDepth}
                            setCartIdx={setCartIndex}
                          />
                        )
                      })}
                  </div>
                </div>
              )}

              <div ref={obsRef}></div>

              {isMobile ? <Hr8></Hr8> : null}

              <div className='more_exhibition'>
                {eventData?.length !== 0 && <p>다른 기획전/이벤트 보기</p>}
                <div className='more_list'>
                  {eventData?.map((el) => {
                    return isMobile ? (
                      <a
                        href={`/exhibitiondetail/${el?.eventNo}`}
                        key={el?.eventNo}
                        onClick={(e) => navigationHandler(e, 'exhibitionDetail', el)}
                      >
                        <img
                          src='../../images/exhibition_more_bg.png'
                          style={{
                            backgroundImage: `url(${isMobile ? el?.mobileimageUrl : el?.pcImageUrl})`,
                          }}
                          alt=''
                        />
                        <div>
                          <p>{el?.label}</p>
                          {el.displayPeriodType === 'REGULAR' ||
                          el?.endYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ') ===
                            '2099. 12. 31' ? (
                            <span>상시 운영</span>
                          ) : (
                            <span>{`${el?.startYmdt
                              ?.split(' ', 1)
                              .join('')
                              .replaceAll('-', '. ')
                              .replaceAll('. 0', '. ')} - ${el?.endYmdt
                              ?.split(' ', 1)
                              .join('')
                              .replaceAll('-', '. ')
                              .replaceAll('. 0', '. ')}`}</span>
                          )}
                        </div>
                      </a>
                    ) : (
                      <div key={el?.eventNo}>
                        <a
                          href={`/exhibitiondetail/${el?.eventNo}`}
                          onClick={(e) => navigationHandler(e, 'exhibitionDetail', el)}
                        >
                          <img
                            src='../../images/exhibition_more_bg.png'
                            style={{
                              backgroundImage: `url(${isMobile ? el?.mobileimageUrl : el?.pcImageUrl})`,
                            }}
                            alt=''
                          />
                        </a>
                        <div>
                          <p>{el?.label}</p>
                          {el.displayPeriodType === 'REGULAR' ||
                          el?.endYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ') ===
                            '2099. 12. 31' ? (
                            <span>상시 운영</span>
                          ) : (
                            <span>{`${el?.startYmdt
                              ?.split(' ', 1)
                              .join('')
                              .replaceAll('-', '. ')
                              .replaceAll('. 0', '. ')} - ${el?.endYmdt
                              ?.split(' ', 1)
                              .join('')
                              .replaceAll('-', '. ')
                              .replaceAll('. 0', '. ')}`}</span>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
                <button
                  style={{
                    marginTop: isMobile ? (eventData?.length !== 0 ? '16px' : '0') : '48px',
                  }}
                  onClick={(e) => navigationHandler(e, 'exhibitionList')}
                  className='btn_list'
                >
                  목록 보기
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {isModal &&
        (isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={productList}
            promotion_id={Number(params?.eventNo) || 0}
            promotion_name={eventDetailData?.label}
            idx={cartIndex}
            promotionCategory={categoryMenu?.flatCategories?.find((item) => item.depth2CategoryNo === params.eventNo)}
            promotionCategory2={findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0)?.categoryNo}
          />
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={productList}
            promotion_id={Number(params?.eventNo) || 0}
            promotion_name={eventDetailData?.label}
            idx={cartIndex}
            promotionCategory={categoryMenu?.flatCategories?.find((item) => item.depth2CategoryNo === params.eventNo)}
            promotionCategory2={findSelectedCategoryItem(categoryMenu?.multiLevelCategories || [], 3, 0)?.categoryNo}
          />
        ))}
    </>
  )
}

interface CategoryWrapProps {
  $isAll: boolean
}

export const CategoryWrap = styled.div<CategoryWrapProps>`
  /* 모바일: 3depth 카테고리 영역 */
  padding: 4px 0 0 0;
  border-bottom: ${({ $isAll }) => ($isAll ? '1px var(--colGray3) solid' : 'none')};
  & .swiper {
    position: relative;
    top: 2px;
    padding: 0 20px;
  }

  &.fixed {
    /* padding-bottom: 48px; */
    & .swiper {
      position: fixed;
      top: 48px;
      left: 0;
      width: 100%;
      background-color: var(--colWhite);
      z-index: 10;
      padding: 0 20px;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${({ $isAll }) => ($isAll ? 'var(--colGray3)' : 'transparent')};
        z-index: -1;
      }
    }
  }
  & div.category {
    position: relative;
    width: 100%;
    padding: 0;
    top: 1px;
  }

  @media screen and (min-width: 768px) {
    padding: 4px 0 0 0;
    border-bottom: none;
    border-bottom: ${({ $isAll }) => ($isAll ? '1px solid var(--colGray3)' : 'none')};

    & .inner {
      /* border-bottom: ${({ $isAll }) => ($isAll ? '1px solid var(--colGray3)' : 'none')}; */
      border: none;
      background: none;
      padding: 0 32px;
    }

    & .swiper {
      position: relative;
      top: 0;
      padding: 0;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${({ $isAll }) => ($isAll ? 'var(--colGray3)' : 'none')};
        z-index: -1;
        display: none;
      }
    }
    &.fixed {
      position: fixed;
      top: 84px;
      height: 50px;
      width: 100%;
      padding: 0;
      border-bottom: ${({ $isAll }) => ($isAll ? '1px solid var(--colGray3)' : 'none')};
      z-index: 10;
      & .inner {
        width: 100%;
        height: 50px;
        z-index: 30;
      }
      & .swiper {
        position: relative;
        top: -1px;
        background: none;
        width: 1216px;
        margin: 0 auto;
        z-index: 10;
        padding: 0;
      }
    }
  }
  & div.category {
    position: relative;
    width: 100%;
    height: 50px;
    background: none;
    padding: 0;
    border-bottom: 1px solid var(--colGray3);
    & div.category::after {
      width: 100%;
      display: block;
      height: 1px;
      position: absolute;
      bottom: 0px;
    }
  }
`

export const SwiperWrap = styled(Swiper)`
  overflow: hidden;
  z-index: 1;
  padding: 0 20px;

  & div.swiper-wrapper {
    & div.swiper-slide {
      width: auto !important;
      position: relative;
      & a {
        display: block;
        padding: 15px 2px;
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
        color: #a3a3a3;
      }
    }
    & div.on {
      & ::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: var(--colBlack);
        left: 0;
      }
      a {
        color: var(--colBlack);
        font-weight: 700;
      }
    }
  }
  @media screen and (min-width: 768px) {
    overflow: hidden;
    z-index: 1;
    padding: 0;
    width: 1216px;
    margin: 0 auto;

    & div.swiper-wrapper {
      & div.swiper-slide {
        width: auto !important;
        position: relative;
        & a {
          display: block;
          padding: 16px 2px;
          font-size: 16px;
          font-weight: 500;
          line-height: 18px;
          color: #a3a3a3;
        }
      }
      & div.on {
        & ::after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 2px;
          background: var(--colBlack);
          left: 0;
        }
        a {
          color: var(--colBlack);
          font-weight: 700;
        }
      }
    }
  }
`

interface Category4WrapProps {
  $isAll: boolean
}

// Category4
export const Category4Wrap = styled.div<Category4WrapProps>`
  width: 100%;
  height: 48px;
  background: var(--colWhite);
  border-bottom: ${({ $isAll }) => ($isAll ? '1px solid var(--colGray3)' : 'none')};
  &.fixed {
    padding-bottom: 48px;

    & .swiper {
      position: fixed;
      top: 96px;
      left: 0;
      width: 100%;
      background-color: var(--colWhite);
      z-index: 10;
      padding: 0 20px;
      border-bottom: 1px solid var(--colGray3);
    }
  }
  & div.category4 {
    padding: 0;
    & .inner {
      border-bottom: none;
    }
    & .swiper {
      & .swiper-slide div a {
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        color: var(--colGray5);
      }
      & .swiper-slide div.on a {
        color: var(--colBlack);
      }
    }
  }
  &.exhibition_category_header4 .swiper {
    /* padding: 0; */
  }

  /* 기획전 PC Category4 */
  @media screen and (min-width: 768px) {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid var(--colGray3);
    &.fixed {
      position: fixed;
      top: 132px;
      width: 100%;
      height: 50px;
      padding-bottom: 0;
      border-bottom: 1px solid var(--colGray3);
      z-index: 20;
      & .swiper {
        position: relative;
        top: 1px;
        width: 1216px;
        margin: 0 auto;
        background: none;
        z-index: 10;
        padding: 0;
        border-bottom: none;
      }
    }
    & div.category4 {
      padding: 0;
      /* border-bottom: 1px solid var(--colGray3); */
      & .inner {
        width: 1216px;
        margin: 0 auto; // PC 4뎁스 swiper 가운데 정렬
        border-bottom: none;
      }
      & .swiper {
        width: 1216px;
        margin: 0 auto;
        & .swiper-slide div a {
          font-size: 16px;
          font-weight: 400;
          line-height: 18px;
          color: var(--colGray5);
        }
        & .swiper-slide div.on a {
          color: var(--colBlack);
        }
      }
    }
    &.exhibition_category_header4 .swiper {
      /* padding: 0; */
    }
  }
`

// Category Four Submenu
export const CategoryFourSubMenuWrap = styled.div`
  width: 100%;
  height: 48px;
  background: var(--colWhite);
  border-bottom: 1px solid var(--colGray3);

  &.fixed {
    position: fixed;
    top: 220px;
    left: 0;
    width: 100%;
    z-index: 20;
    & .swiper {
      width: 100%;
      background-color: var(--colWhite);
      z-index: 10;
      padding: 0 20px;
      border-bottom: 1px solid var(--colGray3);
    }
  }
  & div.category_four_submenu {
    padding: 0;
    & .inner {
      border-bottom: none;
    }
    & .swiper {
      & .swiper-slide div a {
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        color: var(--colGray5);
      }
      & .swiper-slide div.on a {
        color: var(--colBlack);
      }
      & .swiper-slide div.on a::after {
        display: none;
      }
    }
  }
  &.exhibition_category_header_four_submenu .swiper {
    /* padding: 0; */
  }

  /* 기획전 PC CategoryFourSubMenu */
  @media screen and (min-width: 768px) {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid var(--colGray3);
    &.fixed {
      position: fixed;
      top: 181px;
      width: 100%;
      height: 50px;
      padding-bottom: 0;
      border-bottom: 1px solid var(--colGray3);
      z-index: 10;
      & .swiper {
        position: relative;
        top: 1px;
        width: 1216px;
        margin: 0 auto;
        background: none;
        z-index: 10;
        padding: 0;
        border-bottom: none;
      }
    }
    & div.category_four_submenu {
      padding: 0;
      /* border-bottom: 1px solid var(--colGray3); */
      & .inner {
        width: 1216px;
        margin: 0 auto; // PC 4뎁스 swiper 가운데 정렬
        border-bottom: none;
      }
      & .swiper {
        width: 1216px;
        margin: 0 auto;
        & .swiper-slide div a {
          font-size: 16px;
          font-weight: 400;
          line-height: 18px;
          color: var(--colGray5);
        }
        & .swiper-slide div.on a {
          color: var(--colBlack);
        }
      }
    }
    &.exhibition_category_header_four_submenu .swiper {
      /* padding: 0; */
    }
  }
`

export default ExhibitionDetail
